import {
  DEFAULT_PROJECT_PROPERTY_TYPE,
  ProjectPropertyType,
} from 'src/constants/project';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const setPropertyType =
  (
    iri: string,
    propertyType: ProjectPropertyType = DEFAULT_PROJECT_PROPERTY_TYPE
  ) =>
  (model: Model) => {
    setDataProperty<ModelData>(model)(model.modelData, 'propertyTypesByIri', {
      ...model.modelData.propertyTypesByIri,
      [iri]: propertyType,
    });
  };
